import { createContext } from 'react';

const PathBuilderContext = createContext({});

export default PathBuilderContext;
